import { useDispatch } from 'react-redux';
import { setDevice } from 'store/slices/common';

export const useDevice = () => {
  const dispatch = useDispatch();

  // 미리보기 페이지(/preview)는 관리자에서 선택한 viewport(PC/모바일)를 직접 제어하므로
  // UA 기반 자동 판별이 매 렌더마다 data-device 를 덮어쓰지 않도록 건너뛴다.
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/preview')) {
    return;
  }

  const varUA = navigator.userAgent.toLowerCase();
  const isTouchDevice = navigator.maxTouchPoints || 'ontouchstart' in document.documentElement;
  const htmlElement = document.querySelector('html');

  if (varUA.indexOf('android') > -1 || varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
    //안드로이드 & IOS
    htmlElement.setAttribute('data-device', 'mobile');
    dispatch(setDevice('mobile'));
  } else {
    if (isTouchDevice >= 1 && varUA.indexOf('windows') < 0 && varUA.indexOf('macintosh') < 0) {
      // touch 가능 노트북 제외 추가
      htmlElement.setAttribute('data-device', 'mobile');
      dispatch(setDevice('mobile'));
    } else {
      //  pc
      htmlElement.setAttribute('data-device', 'pc');
      dispatch(setDevice('pc'));
    }
  }
};
